/** Vai trò cơ sở của tài khoản đang đăng nhập (user.info.reception_role) */
export const receptionRole = (): string | undefined => {
  try {
    const u = JSON.parse(localStorage.getItem('user') || '{}');
    return (u?.info ?? u)?.reception_role ?? undefined;
  } catch {
    return undefined;
  }
};

/** Tài khoản đang đăng nhập: mã, tên, vai trò cơ sở, cơ sở */
export const accountIdentity = (): { id?: string; name?: string; role?: string; branchId?: string } => {
  try {
    const u = JSON.parse(localStorage.getItem('user') || '{}');
    const x = u?.info ?? u;
    return {
      id: x?.id != null ? String(x.id) : undefined,
      name: x?.name ?? x?.fullname ?? undefined,
      role: x?.reception_role ?? undefined,
      branchId: x?.branch_id != null ? String(x.branch_id) : undefined,
    };
  } catch {
    return {};
  }
};

/** Kỹ thuật viên xem dịch vụ của khách, không xem giá, báo giá (PA, P12) */
export const isTechnicianAccount = () => receptionRole() === 'technician';
